import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "to-invoice"
};
var _hoisted_2 = {
  key: 1,
  class: "to-invoice-details-page-bottom"
};
import OrderStatusCard from "@/components/order/OrderStatusCard.vue";
import OrderCustomerCard from "@/components/order/OrderCustomerCard.vue";
import OrderDetailCard from "@/components/order/OrderDetailCard.vue";
import OrderItemsCard from "@/components/order/OrderItemsCard.vue";
import { getOrderDetail } from "@/api/order";
import { ref, onMounted } from "vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import PoweredBy from "@/components/PoweredBy.vue";
import InvoiceTrigger from "@/components/invoice/InvoiceTrigger.vue";
import { OrderStatusEnum } from "@/constant/order";
import { isTimestampInCurrentMonth } from "@/utils/dateUtil";
export default {
  __name: 'InvoicingDeliveryView',
  setup: function setup(__props) {
    var routes = useRoute();
    var orderId = computed(function () {
      return routes.query.id;
    });
    var order = ref(window.__ORDER_INFO__ || null);
    var fetchData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              showLoading();
              _context.next = 3;
              return getOrderDetail(orderId.value || order.value.order_id);
            case 3:
              res = _context.sent;
              hideLoading();
              if (res.isOK) {
                order.value = res.data;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();
    var isInvoice = computed(function () {
      if (!order.value) return false;
      return order.value.status === OrderStatusEnum.COMPLETED;
    });
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!window.__ORDER_INFO__ && routes.query.id)) {
              _context2.next = 3;
              break;
            }
            _context2.next = 3;
            return fetchData();
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    return function (_ctx, _cache) {
      var _component_Gap = _resolveComponent("Gap");
      var _component_Button = _resolveComponent("Button");
      var _component_Page = _resolveComponent("Page");
      return _openBlock(), _createBlock(_component_Page, {
        title: _ctx.$t('orderDetails'),
        "show-back": false
      }, {
        default: _withCtx(function () {
          var _order$value$invoice_;
          return [order.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(OrderStatusCard, {
            class: "panel",
            order: order.value
          }, null, 8, ["order"]), _createVNode(_component_Gap, {
            h: 0.1
          }), _createVNode(OrderCustomerCard, {
            class: "panel",
            order: order.value
          }, null, 8, ["order"]), _createVNode(_component_Gap, {
            h: 0.1
          }), _createVNode(OrderItemsCard, {
            class: "panel",
            order: order.value
          }, null, 8, ["order"]), _createVNode(_component_Gap, {
            h: 0.1
          }), _createVNode(OrderDetailCard, {
            class: "panel",
            order: order.value
          }, null, 8, ["order"]), _createVNode(PoweredBy)])) : _createCommentVNode("", true), isInvoice.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(InvoiceTrigger, {
            class: "bottom-button-wrap",
            "record-id": ((_order$value$invoice_ = order.value.invoice_info) === null || _order$value$invoice_ === void 0 ? void 0 : _order$value$invoice_.id) || '',
            "order-id": order.value.order_id,
            "shop-id": order.value.op_store.shop_id,
            "order-type": 'delivery',
            onSuccess: fetchData
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_Button, {
                class: "bottom-button",
                type: "border"
              }, {
                default: _withCtx(function () {
                  var _order$value$invoice_2;
                  return [_createTextVNode(_toDisplayString((_order$value$invoice_2 = order.value.invoice_info) !== null && _order$value$invoice_2 !== void 0 && _order$value$invoice_2.id ? _ctx.$t("viewInvoice") : _ctx.$t("issueInvoice")), 1)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["record-id", "order-id", "shop-id"])])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["title"]);
    };
  }
};